import { allowsMotion } from "./motion";
import { entries } from "./registry.entries";
import { destroyDomScripts, destroyElement, runRegistry } from "./registry";

declare global {
	interface Window {
		/** Set by the vendor's optional head snippet; cleared here. See Docs/Drupal Integration. */
		faMotionFallback?: ReturnType<typeof setTimeout>;
	}
}

/** Call at module scope, never from an effect or DOMContentLoaded: both run after the browser has
    painted, so a gated element shows for a frame and then blanks. `fa-motion` is the narrow gate. */
export const markJsReady = (): void => {
	if (typeof document === "undefined") return;

	/* Cancels the head snippet's failsafe. Without this the gate it armed is torn down mid-page
	   three seconds in, and every cascade item appears without ever animating. */
	if (typeof window !== "undefined" && window.faMotionFallback !== undefined) {
		clearTimeout(window.faMotionFallback);
		window.faMotionFallback = undefined;
	}

	document.documentElement.classList.add("fa-js");

	if (allowsMotion()) document.documentElement.classList.add("fa-motion");
};

/** Attaches every matching component inside root, and root itself. Safe to call repeatedly. */
export const initDomScripts = (root: ParentNode = document): Promise<void> => {
	markJsReady();

	return runRegistry(entries, root);
};

export { destroyDomScripts, destroyElement };
